import React from "react";
import { motion } from "framer-motion";

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-[999] flex flex-col items-center justify-center bg-[#0a0a0b]" data-testid="loading-screen">
      <motion.div
        initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="flex flex-col items-center"
      >
        <div className="font-head text-2xl font-extrabold uppercase tracking-tight text-silver">SANJAY LIMITLESS</div>
        <div className="relative mt-6 h-px w-48 overflow-hidden bg-white/10">
          <div className="load-line absolute inset-y-0 w-1/2 bg-gradient-to-r from-transparent via-white to-transparent" />
        </div>
        <div className="mt-5 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">Initializing Workspace</div>
      </motion.div>
    </div>
  );
}
